import { Tenant } from './../models/tenant';
import { TenantService } from './../app-services/tenant.service';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TenantResolveGuard implements Resolve<Tenant> {

  constructor(
    private tenantService: TenantService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    
    let tenant: Tenant;
    if(route.params.tenantCodigo) {
      this.tenantService.getTenantPorCodigo(route.params.tenantCodigo)
                      .subscribe(
                        response => {
                          tenant = response;
                          if(tenant){
                            return tenant;
                          }else{                       
                            this.router.navigate(['404']);
                            return tenant; 
                          }
                        },  
                        error => console.log(error)
                      );
    }
    return tenant;
  }
}



// WEBPACK FOOTER //
// ./src/app/app-guards/tenant.resolver.ts